module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_about-b53d6db19c7fd02c71cd77ed8101d9ae.jpg";